import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PlayerProvider } from "@/context/PlayerContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Browse from "@/pages/Browse";
import MovieDetail from "@/pages/MovieDetail";
import SeriesDetail from "@/pages/SeriesDetail";

const Protected = ({ children }) => {
  const { session, ready } = useAuth();
  if (!ready) return <div className="min-h-screen bg-[#05070A]" />;
  if (!session) return <Navigate to="/login" replace />;
  return children;
};

const LoginGate = () => {
  const { session, ready } = useAuth();
  if (!ready) return <div className="min-h-screen bg-[#05070A]" />;
  if (session) return <Navigate to="/" replace />;
  return <Login />;
};

function App() {
  return (
    <div className="App dark">
      <AuthProvider>
        <BrowserRouter>
          <PlayerProvider>
            <Routes>
              <Route path="/login" element={<LoginGate />} />
              <Route
                path="/"
                element={
                  <Protected>
                    <Browse />
                  </Protected>
                }
              />
              <Route
                path="/movie/:id"
                element={
                  <Protected>
                    <MovieDetail />
                  </Protected>
                }
              />
              <Route
                path="/series/:id"
                element={
                  <Protected>
                    <SeriesDetail />
                  </Protected>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </PlayerProvider>
        </BrowserRouter>
        <Toaster position="top-center" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
